import { ArrowTopRightOnSquareIcon, ArrowUturnLeftIcon, ChevronRightIcon, XMarkIcon } from "@heroicons/react/24/outline";
import React from "react";

const ConfirmationOfPayee: React.FC = () => {
  return (
    <div className="flex flex-col items-center container pt-20">
      {/* Header Section */}
      <header className="w-full px-5">
        <h1 className="text-4xl font-extrabold text-gray-900">What is Confirmation of Payee (CoP)?</h1>
        <p className="mt-4 text-lg text-gray-700">
          Confirmation of Payee (CoP) is an account name-checking service that aims to reduce the risk of accidental or fraudulent payments being sent to the wrong account for UK domestic payments. It operates by verifying the name of the account
          holder you're intending to pay (payee) against the details held by their accounts service provider.
        </p>
      </header>

      <section id="why" className="w-full px-5 my-8 scroll-mt-20">
        <h3 className="text-2xl my-4">How Does CoP Work?</h3>
        <p className="text-gray-800 mb-4">
          1. <strong>Initiating a Payment:</strong> When you initiate a payment to a new payee, we will query the payee's account provider to confirm the account name.
        </p>
        <p className="text-gray-800 mb-4">
          2. <strong>Name Verification:</strong> The payee's account provider compares the account name you've provided with the details on their records.
        </p>
        <p className="text-gray-800 mb-4">
          3. <strong>Result Notification:</strong> You will see a CoP Response on your screen indicating one of the following
        </p>
        <ul className="list-disc pl-5 text-gray-800 mb-4">
          <li>
            <strong>Match:</strong> The names match perfectly.
          </li>
          <li>
            <strong>Close Match:</strong> The names are similar but not identical. You may need to verify the details with the recipient.
          </li>
          <li>
            <strong>No Match:</strong> The names don't match.
          </li>
          <li>
            <strong>No Data:</strong> The account provider does not participate in the Confirmation of Payee service.
          </li>
        </ul>
        <p className="text-gray-800 mb-4">
          4. <strong>Payer’s decision:</strong> Based on the response, you can decide whether to proceed with payment, change payment details, or cancel the payment.
        </p>
      </section>

      <section id="What-this-means" className="w-full px-5 my-8 scroll-mt-20">
        <h4 className="text-xl font-semibold mt-6 mb-2">What if the information provided by the CoP service is wrong?</h4>
        <p className="text-gray-800 mb-2">
          Although, highly unlikely, errors can occur. In this case, please let us know as soon as you notice something is wrong and we will try to resolve the issue as soon as possible. The party who is responsible for the error will be liable for
          the losses incurred because of a payment made in error. Rest assured that if an error does occur, our complaints department will investigate the matter, and we will reimburse you for the amount of the payment made in error as a result of an
          incorrect CoP response.
        </p>
      </section>

      <section id="What-this-means" className="w-full px-5 my-8 scroll-mt-20">
        <h4 className="text-xl font-semibold mt-6 mb-2">Important Considerations</h4>
        <p className="text-gray-800 mb-2">
          <strong>Not a Guarantee:</strong> While CoP is a valuable tool, it's not infallible. It's essential to remain vigilant and exercise caution when making payments, especially to unfamiliar recipients.
        </p>
        <p className="text-gray-800 mb-4">
          <strong>Opt-Out Option:</strong> Some individuals may choose to opt out of CoP. However, this can limit the protection offered by the service.
        </p>
        <p className="text-gray-800 mb-4">
          <strong>Staying Informed:</strong> Stay updated on the latest information on fraud an financial crime, and guidance regarding CoP from us and other financial institutions.
        </p>
        <p className="text-gray-800 mb-4">By understanding the principles and implications of Confirmation of Payee, you can make more informed decisions and protect yourself from potential financial risks.</p>
      </section>
    </div>
  );
};

export default ConfirmationOfPayee;
